<template>
  <!-- 弹窗 -->
  <van-dialog
    v-model="isShow"
    :width="width"
    class="modal"
    :close-on-click-overlay="true"
    :show-confirm-button="false"
    :title="title"
    @closed="closed"
  >
    <div class="container">
      <slot name="content" />
    </div>
    <van-button plain size="mini" type="primary" @click="isShow = false"></van-button>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 300
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  watch: {
    value(val) {
      this.isShow = val
    }
  },
  methods: {
    closed() {
      this.$emit('input', false)
      this.$emit('closed', false)
    }
  }
}
</script>

<style lang="less" scoped>
.modal {
  background: transparent;
  padding: 20px;
  p {
    color: #666666;
    font-size: 14px;
    text-align: left;
    line-height: 25px;
    margin-bottom: 15px;
  }
  /deep/ .van-dialog__header {
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .van-button--mini {
    position: absolute;
    padding: 0;
    width: 26px;
    min-width: 26px;
    height: 26px;
    background-image: url(/images/icons/close.png);
    background-color: transparent;
    background-size: 100% 100%;
    top: 10px;
    right: 10px;
  }
}
</style>
